import BrandEntity from "./BrandEntity";
import ColorEntity from "./ColorEntity";
import PriceBookEntity from "./PriceBookEntity";
import SedeEntity from "./SedeEntity";
import TagEntity from "./TagEntity";
import TypeOfFuelEntity from "./TypeOfFuelEntity";
import TypeVehicleEntity from "./TypeVehicleEntity";
import { ImageVariant } from "../../utils/image";

export enum TransmissionCar {
    AUTOMATIC = "Automática",
    MANUAL = "Manual",
}

export enum TraccionCar {
    TRASERA = 0,
    DELANTERA = 2,
    FOURXFOUR = 1,
    FOURXTWO = 3,
}

export default interface CarEntity {
    id: string;
    name: string;
    model: string;
    type: TypeVehicleEntity;
    photoUrl: string;
    images?: string[];
    previewImages?: string[];
    // Variantes de resolucion (srcset) que sirve el backend, keyed por nombre de archivo
    // normalizado (ver imageKey). Vacio/ausente hasta que el backend genere las variantes.
    imageSrcsetByKey?: Record<string, ImageVariant[]>;
    photoUrlSrcset?: ImageVariant[];
    price: number;
    transmission: TransmissionCar;
    year: any;
    rating: number;
    odometer: number;
    brand: BrandEntity;
    typeOfFuel: TypeOfFuelEntity;
    color: ColorEntity;
    priceBook?: PriceBookEntity | undefined;
    description: string;
    tag?: TagEntity | undefined;
    plate: string;
    fullPlate?: string | undefined;
    doors: number;
    motor: string;
    status: string;
    discount_price?: number | undefined;
    url_expertise?: string | null;
    expertise?: string | null;
    id_colserauto?: string | null;
    claims?: boolean;
    amount_claims?: number;
    warranty?: boolean;
    type_warranty?: string;
    types_claims?: string;
    traction?: number;
    garantia7dias?: boolean;
    quantityPersons?: number;
    warranty_type?: string;
    description_ai?: string;
    type_negotiation?: string;
    automas?: boolean;
    automas_pdf?: string | null;
    active?: boolean;
    image_complaint?: string;
    sede?: number | null;
    sede_car?: SedeEntity | any | null;
    factory_warranty_coverage?: string | null;
    // Link de YouTube del video del vehiculo (backend: campo `video_url`).
    videoUrl?: string | null;
    warranty_plan_car?: { id: number; name: string; description?: string } | null;
}
